var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fin-scroll-carousel',{attrs:{"items":_vm.videos},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('div',[_c('fin-video-item',{staticStyle:{"{width":"300px}"},attrs:{"item":item,"item-height":_vm.itemHeight}})],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }